import { useState } from 'react'
import styled from 'styled-components'

import { Button } from '@/components/DEPRECATED_UI/Button'
import SlideInSidebar from '@/components/DEPRECATED_UI/SlideInSidebar'
import { HeaderPill } from '@/components/HeaderPill'
import type { ReferenceTier } from '@/lib/apollo/query/get-applicant'
import { toReferenceTierLabel } from '@/utils/tier'

import { referenceTierStylesMap, sidebarContentMap } from './utils'

export interface Props {
  applicantTier: ReferenceTier
}

const SidebarButtons = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;

  button {
    margin-right: 0px;
  }
`

export const ReferenceTierPill = ({ applicantTier }: Props) => {
  const [showSidebar, setShowSidebar] = useState<boolean>(false)
  const referenceTierLabel = toReferenceTierLabel(applicantTier)

  const handleClose = () => setShowSidebar(false)

  return (
    <>
      <HeaderPill
        label={referenceTierLabel}
        onClick={() => setShowSidebar(true)}
        {...referenceTierStylesMap[applicantTier]}
      />
      {showSidebar && (
        <SlideInSidebar
          header={<h1>{referenceTierLabel}</h1>}
          content={
            <div>
              {sidebarContentMap[applicantTier]}
              <SidebarButtons>
                <Button alternate onClick={handleClose}>
                  Close
                </Button>
              </SidebarButtons>
            </div>
          }
          onClose={handleClose}
        />
      )}
    </>
  )
}
